import React, { useState } from 'react';
import { Menu, Input, Icon } from 'semantic-ui-react';
import CardMCOldVSNew from './CardMCOldVSNew';
import CardMCDivideGenderAge from './CardMCDivideGenderAge';
import CardMCRepeatInSixMonth from './CardMCRepeatInSixMonth';
import CardMCNewUser from './CardMCNewUser';
import CardMCNewUserAgeGender from './CardMCNewUserAgeGender';
import CardMC2Panel from './CardMC2Panel';

type CardMCCustomerInsightsProps = {
  // Add props if needed
  controller: any,
  runSequence: any,
  MeChartSequence: any,
}


const CardMCCustomerInsights = (props: CardMCCustomerInsightsProps) => {
  const [activeItem, setActiveItem] = useState('oldVsNew');
  const [filterText, setFilterText] = useState('');

  const menuItems = [
    { id: 'oldVsNew', label: 'จำนวนผู้รับบริการ เก่า vs ใหม่' },
    { id: 'genderAge', label: 'จำนวนผู้รับบริการ แยกตามเพศ และ อายุ' },
    { id: 'repeat', label: 'จำนวนครั้งที่ลูกค้ากลับมาซ้ำภายใน 6 เดือน' },
    { id: 'newUser', label: 'จำนวนสมาชิกใหม่' },
    { id: 'newUserAgeGender', label: 'จำนวนสมาชิกใหม่ แยกตาม เพศ และ อายุ' },
  ];

  const filteredItems = menuItems.filter(item =>
    item.label.toLowerCase().includes(filterText.toLowerCase())
  );

  const leftPanelContent = (
    <>
      <div className="search-container">
        <Input
          icon='search'
          placeholder='Search reports...'
          fluid
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>
      <Menu fluid vertical tabular className="nav-menu">
        {filteredItems.map(item => (
          <Menu.Item
            key={item.id}
            active={activeItem === item.id}
            onClick={() => setActiveItem(item.id)}

          >
            <div className="item-content">
              <span>{item.label}</span>
              {activeItem === item.id && <Icon name='chevron right' className="icon" />}
            </div>
          </Menu.Item>
        ))}
      </Menu>
    </>
  );

  return (
    <div id="card-mc-customer-insights">
      <CardMC2Panel
        leftPanel={
          <div className="left-panel-container">
            {leftPanelContent}
          </div>
        }
        rightPanel={
          <div className="right-panel-container">
            {activeItem === 'oldVsNew' && <CardMCOldVSNew controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
            {activeItem === 'genderAge' && <CardMCDivideGenderAge controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
            {activeItem === 'repeat' && <CardMCRepeatInSixMonth controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
            {activeItem === 'newUser' && <CardMCNewUser controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
            {activeItem === 'newUserAgeGender' && <CardMCNewUserAgeGender controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
          </div>
        }
      />
    </div>
  );
};

export default CardMCCustomerInsights;
